import { render } from "./Virus.vue?vue&type=template&id=6f27300e&scoped=true"
import script from "./Virus.vue?vue&type=script&lang=js"
export * from "./Virus.vue?vue&type=script&lang=js"

import "./Virus.vue?vue&type=style&index=0&id=6f27300e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f27300e"]])

export default __exports__